import React from "react";

// Shared light, professional auth layout — matches the Login page.
export default function AuthShell({ children, maxWidth = "max-w-md" }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10 font-Rajdhani">
            <div className={`w-full ${maxWidth}`}>
                <div className="text-center mb-6">
                    <img src="/assets/Flash-logo-light.png" alt="Content Flash AI" className="h-9 w-auto object-contain mx-auto" />
                </div>
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-7 sm:p-8">
                    {children}
                </div>
            </div>
        </div>
    );
}

export const authInputCls = "w-full pl-10 pr-3 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-900 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition";
export const authPrimaryBtn = "w-full py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition disabled:opacity-60";
